import Const from '@/const/index';
export default Const;
